var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrustlogoside({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 94,
    viewBox: "0 0 190 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.298 21.5342L87.7664 30.1865L77.6162 32.7836L83.3949 23.8122L92.298 21.5342Z",
    fill: "#263BD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.361 32.7836L105.21 30.1865L100.679 21.5342L109.582 23.8122L115.361 32.7836Z",
    fill: "#263BD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1229 37.1404L77.0547 50.6297H66.1199L74.8101 37.1404H84.1229Z",
    fill: "#263BD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.857 50.6297H115.922L108.854 37.1404H118.166L126.857 50.6297Z",
    fill: "#263BD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.825 50.6299H78.1514L96.4869 37.1406L114.825 50.6299Z",
    fill: "#263BD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.042 18.3183H98.9937L96.4876 13.5375L93.9835 18.3183H86.9355L95.6441 4.79888L96.4876 3.48828L97.3331 4.79888L106.042 18.3183Z",
    fill: "#263BD4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6025 69.7646L24.9613 90.13H19.1016L16.0176 76.6207L12.8829 90.13H7.08196L2.4043 69.7646H7.29891L10.0808 84.3277L13.3391 69.7646H18.6859L21.9422 84.3939L24.7362 69.7646H29.6025Z",
    fill: "#263BD4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4595 69.7648V90.1302H43.5223V81.9856H36.4258V90.1322H31.4744V69.7648H36.4176V77.6183H43.5142V69.7648H48.4595Z",
    fill: "#263BD4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9572 69.7648H56.9025V90.1302H51.9572V69.7648Z",
    fill: "#263BD4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9071 74.1301H69.9257V90.1302H64.9824V74.1301H59.0031V69.7648H75.9071V74.1301Z",
    fill: "#263BD4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2556 85.8813V90.1302H78.0077V69.7648H92.0975V74.0137H82.951V77.6765H90.9742V81.9254H82.951V85.8813H92.2556Z",
    fill: "#263BD4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7842 79.9629C93.7842 73.8093 98.403 69.3838 104.502 69.3838C109.889 69.3838 113.235 72.7255 114.235 76.0953L109.498 78C108.878 75.5916 107.219 74.014 104.376 74.014C101.092 74.014 98.8106 76.3883 98.8106 79.9629C98.8106 83.5374 101.092 85.8816 104.348 85.8816C107.219 85.8816 108.878 84.3001 109.498 81.8977L114.235 83.8023C113.17 87.2886 109.794 90.5119 104.437 90.5119C98.403 90.5119 93.7842 86.0863 93.7842 79.9629Z",
    fill: "#263BD4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.79 82.0136H121.251V90.13H116.342V69.7646H124.987C129.487 69.7646 132.299 72.3437 132.299 75.8881C132.299 78.8485 130.255 81.1927 126.94 81.837L132.743 90.13H127.236L121.79 82.0136ZM121.251 78.5555H124.839C126.496 78.5555 127.475 77.7065 127.475 76.2996C127.475 74.8926 126.498 74.0436 124.839 74.0436H121.251V78.5555Z",
    fill: "#263BD4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.664 69.7646V82.13C151.664 86.702 148.882 90.5114 143.227 90.5114C137.572 90.5114 134.731 86.698 134.731 82.13V69.7646H139.701V82.1019C139.701 84.3578 140.855 85.8811 143.223 85.8811C145.561 85.8811 146.717 84.3578 146.717 82.1019V69.7646H151.664Z",
    fill: "#263BD4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.789 85.1491L158.467 83.3628C158.97 85.2675 160.419 86.2931 162.343 86.2931C164.03 86.2931 164.919 85.6187 164.919 84.5048C164.919 80.842 154.677 82.863 154.677 75.5374C154.677 71.9247 157.341 69.3838 162.167 69.3838C166.074 69.3838 168.858 71.3467 169.596 74.1605L164.949 75.9488C164.505 74.3071 163.41 73.5404 161.93 73.5404C160.391 73.5404 159.62 74.2147 159.62 75.146C159.62 78.6623 169.923 76.6412 169.923 84.3784C169.923 87.981 166.904 90.5018 161.871 90.5018C157.875 90.5119 154.825 88.5771 153.789 85.1491Z",
    fill: "#263BD4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M187.595 74.1301H181.616V90.1302H176.671V74.1301H170.691V69.7648H187.595V74.1301Z",
    fill: "#263BD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrustlogoside);
export default __webpack_public_path__ + "static/media/crustlogoside.4955f1def446bd368e4bd32ec0de967c.svg";
export { ForwardRef as ReactComponent };